var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 10.5C5.83398 6.65024 5.83398 4.72534 7.02997 3.52935C8.22595 2.33337 10.1508 2.33337 14.0007 2.33337C17.8505 2.33337 19.7754 2.33337 20.9713 3.52935C22.1673 4.72534 22.1673 6.65024 22.1673 10.5V17.5C22.1673 21.3498 22.1673 23.2747 20.9713 24.4707C19.7754 25.6667 17.8505 25.6667 14.0007 25.6667C10.1508 25.6667 8.22595 25.6667 7.02997 24.4707C5.83398 23.2747 5.83398 21.3498 5.83398 17.5V10.5Z",
    stroke: "#47525D",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 22.1666H15.1673",
    stroke: "#47525D",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.33337L10.6038 2.95639C10.8289 4.30655 10.9414 4.98163 11.4044 5.39242C11.8874 5.82094 12.5722 5.83337 14 5.83337C15.4278 5.83337 16.1126 5.82094 16.5956 5.39242C17.0586 4.98163 17.1711 4.30655 17.3962 2.95639L17.5 2.33337",
    stroke: "#47525D",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6f4918d50b7bc4d418e188d689bb456a.svg";
export { ForwardRef as ReactComponent };